export const assetOwnerRulesHelperText = 'Choose the asset fields that you want to export to a file.';
export const networkOperatorRulesHelperText = 'Choose the asset fields that Asset Consumers will export.';
